import { configureStore } from '@reduxjs/toolkit'
import cordinaData from '../reducers/index'

export default function initStore(initialState) {
    const store = configureStore({
        reducer: cordinaData,
        preloadedState: initialState,
        devTools: false
    })

    return store
}
